import { useEffect, useState } from 'react';
import { parseInitialInvoice } from '../utils/parseInitialInvoice';
export function useDerivedInitialInvoice({
  initialDataFetchData,
  objectTypeId,
  operation,
  setNumCompaniesRemoved,
  setNumContactsRemoved,
  useBillingContactOnQuotesAndDealsInvoices,
  isUngatedToInvoicesNetTerms,
  propertyBlockList,
  derivedPaymentsEligibility
}) {
  const [derivedInitialInvoice, setDerivedInitialInvoice] = useState(null);
  useEffect(() => {
    if (!initialDataFetchData || !derivedPaymentsEligibility) {
      setDerivedInitialInvoice(null);
      return;
    }
    parseInitialInvoice(initialDataFetchData, objectTypeId, operation, setNumCompaniesRemoved, setNumContactsRemoved, useBillingContactOnQuotesAndDealsInvoices, isUngatedToInvoicesNetTerms, propertyBlockList, derivedPaymentsEligibility).then(invoice => {
      setDerivedInitialInvoice(invoice);
    }).catch(error => {
      console.error('Error parsing initial invoice:', error);
      setDerivedInitialInvoice(null);
    });
  }, [initialDataFetchData, objectTypeId, operation, propertyBlockList, useBillingContactOnQuotesAndDealsInvoices, derivedPaymentsEligibility, isUngatedToInvoicesNetTerms, setNumCompaniesRemoved, setNumContactsRemoved]);
  return derivedInitialInvoice;
}